import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getFormInstanceTracker } from "../../../services/PharmacyUser";
import dayjs from "dayjs";

const FormInstanceTracker = (props) => {
  const { formInstance } = props;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (formInstance.id) {
      getFormInstanceTracker(formInstance.id).then((res) => {
        setRows(
          res.data.map((row) => ({
            ...row,
            actionDate: dayjs(row.actionDate).format("YYYY-MM-DD hh:mm a"),
            firstName: row.userDetails.first,
            lastName: row.userDetails.last,
            email: row.userDetails.email,
            phone: row.userDetails.phone,
            type: row.userDetails.type,
            active: row.userDetails.active ? true : false,
          }))
        );
      });
    }
  }, [formInstance]);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "actionDate", headerName: "Action Date", width: 180 },
    { field: "actionType", headerName: "Action Type", width: 130 },
    { field: "actionUser", headerName: "Action User ID", width: 120 },
    { field: "surveyId", headerName: "Survey ID", width: 100 },
    { field: "actionDetails", headerName: "Action Details", width: 200 },
    { field: "firstName", headerName: "First Name", width: 130 },
    { field: "lastName", headerName: "Last Name", width: 130 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "type", headerName: "User Type", width: 150 },
    {
      field: "active",
      headerName: "Active Status",
      width: 120,
      type: "boolean",
    },
  ];

  const paginationModel = { page: 0, pageSize: 50 };

  return (
    <div className="dg_1liner">
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10, 25, 50, 100]}
        slots={{ toolbar: GridToolbar }}
      />
    </div>
  );
};

export default FormInstanceTracker;
